import { FilterKeyBoolean, FilterKeyNumber, FilterKeyString, Tracker } from "../types";

const SERVER_URL_FILTER_ALL_VALUE = 'ALL';
const SERVER_PORT_FILTER_ALL_VALUE = -1;

const regexpFilgterBattery = /^(<|>|=|)([0-9]+)$/;
const regexpFilgterDate = /^(<|>|=|)([0-9]{4}(-|\/)[0-9]{2}(-|\/)[0-9]{2}( [0-9]{2}:[0-9]{2}:[0-9]{2})?)$/;
const regexpFilgterVersion = /^(<|>|=|)([0-9]+)$/;

type TrackersPageFilterState = {
    filter_open: boolean;
    filter_name: string;
    filter_hardwareId: string;
    filter_battery: string;
    filter_version: string;
    filter_date: string;
    filter_viewNoUpdatable: boolean;
    filter_viewUpdatable: boolean;
    filter_server: string;
    filter_port: number;
    filter_transversal_search: string;
    filter_fleetstate: string;
}

const EmptyFilter: TrackersPageFilterState = {
    filter_open: false,
    filter_name: '',
    filter_hardwareId: '',
    filter_battery: '',
    filter_version: '',
    filter_date: '',
    filter_viewNoUpdatable: true,
    filter_viewUpdatable: true,
    filter_server: SERVER_URL_FILTER_ALL_VALUE,
    filter_port: SERVER_PORT_FILTER_ALL_VALUE,
    filter_transversal_search: '',
    filter_fleetstate: 'ALL',
}

const LOCALSTORAGE_FILTER_KEY = 'RedirectionFilter';
const item = localStorage.getItem(LOCALSTORAGE_FILTER_KEY);

let FILTER: TrackersPageFilterState = item ? { ...EmptyFilter, ...JSON.parse(item) } : {
    ...EmptyFilter,
};

function isNameOK(tracker: Tracker, filter: string): boolean {
    if (tracker.name.toLowerCase().indexOf(filter.toLowerCase()) === -1) {
        return false;
    }
    return true;
}

function isHardwareIdOK(tracker: Tracker, filter: string): boolean {
    if (tracker.hardware_id.toLowerCase().indexOf(filter.toLowerCase()) === -1) {
        return false;
    }
    return true;
}

function isServerNameOK(tracker: Tracker, filter: string, isPartial: boolean): boolean {
    if (!isPartial && filter !== SERVER_URL_FILTER_ALL_VALUE && tracker.server_url !== filter) {
        return false;
    }
    if (isPartial && tracker.server_url.toLowerCase().indexOf(filter.toLowerCase()) === -1) {
        return false;
    }
    return true;
}

function filter(tracker: Tracker, index: number): boolean {
    if (!isNameOK(tracker, FILTER.filter_name)) {
        return false;
    }
    if (!isHardwareIdOK(tracker, FILTER.filter_hardwareId)) {
        return false;
    }
    if (FILTER.filter_battery.length > 0) {
        const values = FILTER.filter_battery.match(regexpFilgterBattery);
        if (values) {
            const symbol = values[1];
            const value = Number(values[2]);
            if (symbol === '<' && value <= tracker.battery) {
                return false;
            }
            if (symbol === '>' && value >= tracker.battery) {
                return false;
            }
            if (symbol === '=' && value !== tracker.battery) {
                return false;
            }
            if (symbol === '' && value !== tracker.battery) {
                return false;
            }
        }
    }
    if (FILTER.filter_version.length > 0) {
        const values = FILTER.filter_version.match(regexpFilgterVersion);
        if (values) {
            const symbol = values[1];
            const value = Number(values[2]);
            if (symbol === '<' && value <= tracker.version) {
                return false;
            }
            if (symbol === '>' && value >= tracker.version) {
                return false;
            }
            if (symbol === '=' && value !== tracker.version) {
                return false;
            }
            if (symbol === '' && value !== tracker.version) {
                return false;
            }
        }
    }
    if (FILTER.filter_date.length > 0) {
        const values = FILTER.filter_date.match(regexpFilgterDate);
        if (values) {
            const symbol = values[1];
            const value = (new Date(values[2])).getTime();
            if (symbol === '<' && value <= tracker.last) {
                return false;
            }
            if (symbol === '>' && value >= tracker.last) {
                return false;
            }
            if (symbol === '=' && value !== tracker.last) {
                return false;
            }
            if (symbol === '' && value !== tracker.last) {
                return false;
            }
        }
    }
    if (!FILTER.filter_viewNoUpdatable) {
        if (!tracker.updatable) {
            return false;
        }
    }
    if (!FILTER.filter_viewUpdatable) {
        if (tracker.updatable) {
            return false;
        }
    }
    if (!isServerNameOK(tracker, FILTER.filter_server, false)) {
        return false;
    }
    if (FILTER.filter_port !== SERVER_PORT_FILTER_ALL_VALUE && tracker.server_port !== FILTER.filter_port) {
        return false;
    }
    if (FILTER.filter_fleetstate !== 'ALL') {
        const fs = tracker.fleetstate;
        if (FILTER.filter_fleetstate === 'ok' && fs !== 'ok') return false;
        if (FILTER.filter_fleetstate === 'outdated' && !fs.startsWith('outdated:')) return false;
        if (FILTER.filter_fleetstate === 'error' && (fs === 'ok' || fs.startsWith('outdated:'))) return false;
    }
    // Aprés tout les autres
    if (FILTER.filter_transversal_search) {
        if (isNameOK(tracker, FILTER.filter_transversal_search)) {
            return true;
        }
        if (isHardwareIdOK(tracker, FILTER.filter_transversal_search)) {
            return true;
        }
        if (isServerNameOK(tracker, FILTER.filter_transversal_search, true)) {
            return true;
        }
        return false;
    }
    return true;
}

function switchFilter(key: FilterKeyBoolean) {
    FILTER[key]= !FILTER[key];
    localStorage.setItem(LOCALSTORAGE_FILTER_KEY, JSON.stringify(FILTER))
}

function setString(key: FilterKeyString, value: string): void {
    FILTER[key] = value;
    localStorage.setItem(LOCALSTORAGE_FILTER_KEY, JSON.stringify(FILTER))
}

function setNumber(key: FilterKeyNumber, value: string): void {
    const number = Number(value);
    if (!isNaN(number)) {
        FILTER[key] = number;
        localStorage.setItem(LOCALSTORAGE_FILTER_KEY, JSON.stringify(FILTER))
    }
}

function isCorrectFilterBattery() {
    if (FILTER.filter_battery === '') {
        return true;
    }
    if (FILTER.filter_battery.match(regexpFilgterBattery)) {
        return true;
    }
    return false;
}

function isCorrectFilterDate() {
    if (FILTER.filter_date === '') {
        return true;
    }
    const match = FILTER.filter_date.match(regexpFilgterDate)
    if (match) {
        return true;
    }
    return false;
}

function isCorrectFilterVersion() {
    if (FILTER.filter_version === '') {
        return true;
    }
    if (FILTER.filter_version.match(regexpFilgterVersion)) {
        return true;
    }
    return false;
}

function isOpen() {
    return FILTER.filter_open;
}

function getBoolean(key: FilterKeyBoolean): boolean {
    return FILTER[key];
}

function getString(key: FilterKeyString): string {
    return FILTER[key];
}

function getNumber(key: FilterKeyNumber): number {
    return FILTER[key];
}

function hasFilter(): boolean {
    const filter1 = EmptyFilter;
    const filter2 = FILTER;
    return !(filter1.filter_name === filter2.filter_name
        && filter1.filter_hardwareId === filter2.filter_hardwareId
        && filter1.filter_battery === filter2.filter_battery
        && filter1.filter_version === filter2.filter_version
        && filter1.filter_date === filter2.filter_date
        && filter1.filter_server === filter2.filter_server
        && filter1.filter_port === filter2.filter_port
        && filter1.filter_viewNoUpdatable === filter2.filter_viewNoUpdatable
        && filter1.filter_viewUpdatable === filter2.filter_viewUpdatable
        && filter1.filter_transversal_search === filter2.filter_transversal_search
        && filter1.filter_fleetstate === filter2.filter_fleetstate)
}

function reinit(): void {
    const open = FILTER.filter_open
    FILTER = {
        ...EmptyFilter,
        filter_open: open,
    };
}

const FilterService = {
    SERVER_URL_FILTER_ALL_VALUE,
    SERVER_PORT_FILTER_ALL_VALUE,
    filter,
    switchFilter,
    setString,
    setNumber,
    isCorrectFilterBattery,
    isCorrectFilterDate,
    isCorrectFilterVersion,
    isOpen,
    getBoolean,
    getString,
    getNumber,
    hasFilter,
    reinit,
}

export default FilterService;
